import { apiClient } from '../api/apiClient';

export const accountService = {
    register(payload, credentials = 'same-origin') {
        return apiClient.post('account/register', {
            credentials,
            json: payload
        });
    },

    getCurrentUser() {
        return apiClient.get('account/current-user');
    },

    logout() {
        return apiClient.get('account/logout');
    },

    login(loginIdentifier, password) {
        return apiClient.post('account/login', {
            json: {
                LoginIdentifier: loginIdentifier,
                Password: password
            }
        });
    },

    sendOtp(mobileNumber, userId = null, credentials = 'same-origin') {
        return apiClient.post('account/send-otp', {
            credentials,
            json: { mobileNumber, userId }
        });
    },

    verifyOtp(mobileNumber, otp, userId = null, credentials = 'same-origin') {
        return apiClient.post('account/verify-otp', {
            credentials,
            json: { mobileNumber, otp, userId }
        });
    },

    resetPassword(token, newPassword, credentials = 'same-origin') {
        return apiClient.post('user/reset-password', {
            credentials,
            json: {
                Token: token,
                NewPassword: newPassword
            }
        });
    },

    forgotPassword(email, credentials = 'same-origin') {
        return apiClient.post('user/forgot-password', {
            credentials,
            json: { Email: email }
        });
    },

    searchAccounts(query) {
        return apiClient.get(`account/search?query=${encodeURIComponent(query)}`);
    }
};
